var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-section",class:{ 'is-closeable': _vm.isCloseable }},[_c('div',{on:{"click":_vm.onClose}},[(_vm.isCloseable)?_c('CloseButton',{staticClass:"close-button-container"}):_vm._e()],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }